import { render } from "./SubpageVouchers.vue?vue&type=template&id=844c8074"
import script from "./SubpageVouchers.vue?vue&type=script&lang=js"
export * from "./SubpageVouchers.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__